module.exports = __webpack_public_path__ + "static/media/banner4.9d31c820.png";